<div class="grid-container padding-y-4">
  <div class="grid-row">
    <div class="grid-col-8">
      <legend class="usa-legend usa-legend--large">Shipment Addresses</legend>
    </div>
    <div class="grid-col-4">
      <h6 class="font-weight-light font-italic text-info">Please enter both origin and destination addresses to save
      addresses</h6>
    </div>
  </div>
  @if (vm$ | async; as vm) {
    <form [formGroup]="shipmentAddressForm">
      <tabset>
        <tab heading="Origin Addresses" id="originAddress">
          <div class="usa-accordion" aria-multiselectable="true">
            <!-- Use the accurate heading level to maintain the document outline -->
            <h4 class="usa-accordion__heading">
              <button
                class="usa-accordion__button"
                aria-expanded="false"
                aria-controls="m-a1">
                Origin {{ getAddress(vm.originAddress)}}
              </button>
            </h4>
            <div id="m-a1" class="usa-accordion__content usa-prose" hidden>
              <div class="grid-row">
                <button
                  class="usa-button"
                  (click)="openPreferredAddress(vm.user, vm.originAddress)">
                  Select Address
                </button>
              </div>
              <div class="grid-container">
                <app-shipment-address
                  formControlName="origin"
                  [address]="vm.originAddress"
                  [isPrimaryAddress]="true"
                  [states]="vm.states"
                [countries]="vm.countries"></app-shipment-address>
              </div>
            </div>
            <!-- Use the accurate heading level to maintain the document outline -->
            <h4 class="usa-accordion__heading">
              <button
                class="usa-accordion__button"
                aria-expanded="false"
                aria-controls="m-a2">
                Shipper (Optional) {{ getAddress(vm.shipperAddress)}}
              </button>
            </h4>
            <div id="m-a2" class="usa-accordion__content usa-prose" hidden>
              <div class="grid-row">
                <button
                  class="usa-button"
                  (click)="openPreferredAddress(vm.user, vm.shipperAddress)">
                  Select Address
                </button>
              </div>
              <div class="grid-container">
                <app-shipment-address
                  formControlName="shipper"
                  [address]="vm.shipperAddress"
                  [states]="vm.states"
                  [countries]="vm.countries"
                ></app-shipment-address>
              </div>
            </div>
            <!-- Use the accurate heading level to maintain the document outline -->
            <h4 class="usa-accordion__heading">
              <button
                class="usa-accordion__button"
                aria-expanded="false"
                aria-controls="m-a3">
                Bill To {{ getAddress(vm.billToAddress)}}
              </button>
            </h4>
            <div id="m-a3" class="usa-accordion__content usa-prose" hidden>
              <div class="grid-row">
                <button
                  class="usa-button"
                  (click)="copyShipperAddressToBillToAddress(vm.shipperAddress)">
                  Same as Shipper
                </button>
                <button
                  class="usa-button"
                  (click)="openPreferredAddress(vm.user, vm.billToAddress)">
                  Select Address
                </button>
              </div>
              <div class="grid-container">
                <app-shipment-address
                  formControlName="billTo"
                  [address]="vm.billToAddress"
                  [states]="vm.states"
                  [countries]="vm.countries"
                ></app-shipment-address>
              </div>
            </div>
          </div>
        </tab>
        <tab heading="Destination Addresses" id="destinationAddress">
          <div class="usa-accordion" aria-multiselectable="true">
            <!-- Use the accurate heading level to maintain the document outline -->
            <h4 class="usa-accordion__heading">
              <button
                class="usa-accordion__button"
                aria-expanded="false"
                aria-controls="m-b1">
                Destination {{ getAddress(vm.destinationAddress)}}
              </button>
            </h4>
            <div id="m-b1" class="usa-accordion__content usa-prose" hidden>
              <div class="grid-row">
                <button
                  class="usa-button"
                  (click)="openPreferredAddress(vm.user, vm.destinationAddress)">
                  Select Address
                </button>
              </div>
              <div class="grid-container">
                <app-shipment-address
                  formControlName="destination"
                  [address]="vm.destinationAddress"
                  [isPrimaryAddress]="true"
                  [states]="vm.states"
                  [countries]="vm.countries"
                ></app-shipment-address>
              </div>
            </div>
            <!-- Use the accurate heading level to maintain the document outline -->
            <h4 class="usa-accordion__heading">
              <button
                class="usa-accordion__button"
                aria-expanded="false"
                aria-controls="m-b2">
                Consignee (Optional) {{ getAddress(vm.consigneeAddress)}}
              </button>
            </h4>
            <div id="m-b2" class="usa-accordion__content usa-prose" hidden>
              <div class="grid-row">
                <button
                  class="usa-button"
                  (click)="copyDestinationAddressToConsigneeAddress(vm.destinationAddress)">
                  Same as Destination
                </button>
                <button
                  class="usa-button"
                  (click)="openPreferredAddress(vm.user, vm.consigneeAddress)">
                  Select Address
                </button>
              </div>
              <div class="grid-container">
                <app-shipment-address
                  formControlName="consignee"
                  [address]="vm.consigneeAddress"
                  [states]="vm.states"
                  [countries]="vm.countries"
                ></app-shipment-address>
              </div>
            </div>
            <!-- Use the accurate heading level to maintain the document outline -->
            <h4 class="usa-accordion__heading">
              <button
                class="usa-accordion__button"
                aria-expanded="false"
                aria-controls="m-b3">
                Issuing Office {{ getAddress(vm.issuingAddress)}}
              </button>
            </h4>
            <div id="m-b3" class="usa-accordion__content usa-prose" hidden>
              <div class="grid-container">
                <app-shipment-address
                  formControlName="issuingOffice"
                  [isIssuingOffice]="true"
                  [address]="vm.issuingAddress"
                  [states]="vm.states"
                  [countries]="vm.countries"
                ></app-shipment-address>
              </div>
            </div>
          </div>
        </tab>
      </tabset>
      @if (this.isFormInvalidValue.length > 0) {
        <div class="saveErrors grid-row margin-top-4">
          The below address are invalid or incomplete: {{this.isFormInvalidValue.toString()}}
        </div>
      }
      <div class="grid-row margin-top-4">
        <button
          type="submit"
          class="usa-button"
          [disabled]="isSubmitDisable()"
          (click)="onSubmit()">
          Save Addresses
        </button>
        <button
          type="back"
          class="usa-button"
          (click)="goBack()">
          Back to Book Shipments
        </button>
      </div>
    </form>
  }
</div>
@if (saveAddresses$ | async) {
}
